/* eslint-disable no-extra-boolean-cast */
/* eslint-disable max-len */
/* eslint-disable no-param-reassign */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
// eslint-disable-next-line import/no-extraneous-dependencies
import { appendMetadataWithIndex } from 'ml-portals-util-react';
import { MetadataContent } from '@jutro/legacy/uiconfig';
import '@xengage/gw-platform-translations';
import MLPAAgentTermMultipleOptComponent from '../MLPAAgentTermMultipleOptComponent/MLPAAgentTermMultipleOptComponent';
import metadata from './MLPAAgentCovTermComponent.metadata.json5';
import styles from './MLPAAgentCovTermComponent.module.scss';

function MLPAAgentCovTermComponent(props) {
    const {
        coverage,
        index,
        isDisplayOnly,
        disableMexicoAndDeclining,
        hideMexicoDecliningAmount
    } = props;

    const EMPTY_STRING = 'Empty';
    const isEmpty = (obj) => {
        return obj.name === EMPTY_STRING || (obj.name && obj.name.indexOf(`- ${EMPTY_STRING}`) > -1);
    }


    const resolvers = {
        resolveComponentMap: {
            mlpaagenttermmultipleoptcomponent: MLPAAgentTermMultipleOptComponent
        },
        resolveClassNameMap: styles
    };
    const getSingleOption = useCallback((term) => {
        let termValue;
       
        if (term.hasOptions) {
            const chosenTerm = term.options.find((opt) => opt.code === term.value);
           
            termValue = (chosenTerm || term.options[0]).name;
           
            if(isDisplayOnly && term.name === "Coverage Is"){
                if(termValue === "No"){
                    termValue = "Offered and Consented"
                }else{
                    termValue = "Insured Requested"
                }
            }
        } else {
            termValue = term.newValue;
        }
       
        return termValue;
    }, [isDisplayOnly]);


    const generateTermOverrides = useCallback(() => {
        if (_.isNil(coverage.terms)) {
            return {};
        }

        const termOverrides = coverage.terms.map((term, termIndex) => {
            return {
                [`nonEmptyTermDiv${index}${termIndex}`]: {
                    visible: !isEmpty(term) && term.isVisible_ML
                },
                [`loadingDiv${index}${termIndex}`]: {
                    visible: !!term.loading
                },
                [`nonDisplayOnlyDiv${index}${termIndex}`]: {
                    visible: !isDisplayOnly
                },
                [`parentUpdatingCol${index}${termIndex}`]: {
                    className: !!term.updating ? 'col-md-10' : 'col-md-12'
                },
                [`multipeOptCovTermComponent${index}${termIndex}`]: {
                    term: term,
                    getSingleOption,
                    covIndex: index,
                    termIndex: termIndex,
                    coverage,
                    hideMexicoDecliningAmount
                },
                [`displayOnlyDiv${index}${termIndex}`]: {
                    visible: isDisplayOnly
                },
                [`singleOptionCost${index}${termIndex}`]: {
                    content: getSingleOption(term)
                },
                [`termValidation${index}${termIndex}`]: {
                    visible: !!term.validationMessage_ML
                }
            };
        });

        return Object.assign({}, ...termOverrides);
    }, [coverage, getSingleOption, index, isDisplayOnly]);

    const overrides = {
        [`covTermLoop${index}`]: {
            data: coverage.terms
        },
        ...generateTermOverrides()
    };

    const updatedMetadata = appendMetadataWithIndex(metadata.componentContent, index);

    return <MetadataContent uiProps={updatedMetadata} overrideProps={overrides} {...resolvers} />;
}

MLPAAgentCovTermComponent.propTypes = {
    coverage: PropTypes.shape({}),
    index: PropTypes.number,
    isDisplayOnly: PropTypes.bool
};

MLPAAgentCovTermComponent.defaultProps = {
    coverage: {}
};

export default MLPAAgentCovTermComponent;
